export default "__VITE_ASSET__9b0026dc__"